// extracted by mini-css-extract-plugin
export default {"prompt":"prompt_prompt__Tw0Ax"};